// extracted by mini-css-extract-plugin
export default {"PersonalizationShape":"PersonalizationShape_PersonalizationShape__AMic0","building":"PersonalizationShape_building__gJVwx","active":"PersonalizationShape_active__yEed4"};